import { ShoppingBag, Zap, Crown, Car, Wallet } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const DISCORD_URL = "https://discord.gg/mjc3uWVbGj";

const TEASERS = [
  {
    icon: Zap,
    title: "Priority Queue",
    text: "Skip the line and get into the city faster during peak hours.",
  },
  {
    icon: Crown,
    title: "Supporter Pack",
    text: "Exclusive supporter badge, Discord role, and cosmetics to rep Southside.",
  },
  {
    icon: Car,
    title: "Custom Vehicle Slot",
    text: "Bring your dream ride into the city with a dedicated import slot.",
  },
  {
    icon: Wallet,
    title: "Starter Cash Pack",
    text: "A head start for your character's story — balanced within server economy rules.",
  },
];

export default function Store() {
  return (
    <div className="min-h-screen bg-plum-900" data-testid="store-page">
      <Navbar />
      <section className="relative overflow-hidden pt-20">
        <div className="absolute inset-0 retro-grid" />
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 text-center">
          <div className="inline-flex items-center gap-2 rounded-full border border-sunset-amber/40 bg-sunset-amber/10 px-5 py-2 mb-8 animate-fade-up" data-testid="store-coming-soon-badge">
            <ShoppingBag className="h-4 w-4 text-sunset-amber" />
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-sunset-amber">Coming Soon</span>
          </div>
          <h1 className="font-display font-extrabold uppercase leading-[0.9] text-4xl sm:text-5xl lg:text-6xl tracking-tight text-cream animate-fade-up" style={{ animationDelay: "120ms" }} data-testid="store-title">
            The Southside <span className="sunset-text">Store</span>
          </h1>
          <p className="mt-5 max-w-xl mx-auto text-base sm:text-lg text-muted-foreground animate-fade-up" style={{ animationDelay: "240ms" }}>
            Support the server and unlock perks that keep the city running. The store is under
            construction — join the Discord to get notified the moment it opens.
          </p>
          <a
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="store-discord-cta"
            className="btn-sunset rounded-full px-8 py-3 text-sm font-bold uppercase tracking-wider inline-block mt-8 animate-fade-up"
            style={{ animationDelay: "360ms" }}
          >
            Get Notified on Discord
          </a>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {TEASERS.map((t, i) => (
            <div
              key={t.title}
              data-testid={`store-teaser-card-${i}`}
              className="relative glow-card rounded-2xl border border-sunset-amber/20 bg-plum-700/70 p-6 sm:p-8 animate-fade-up"
              style={{ animationDelay: `${120 + i * 90}ms` }}
            >
              <span className="absolute top-4 right-4 rounded-full bg-plum-800 border border-sunset-amber/30 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-muted-foreground" data-testid={`store-teaser-badge-${i}`}>
                Soon
              </span>
              <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-sunset-amber to-sunset-orange flex items-center justify-center mb-5">
                <t.icon className="h-5 w-5 text-plum-900" />
              </div>
              <h3 className="font-display text-xl font-semibold uppercase tracking-wide text-cream mb-2">{t.title}</h3>
              <p className="text-sm leading-relaxed text-muted-foreground">{t.text}</p>
            </div>
          ))}
        </div>
        <p className="text-center text-xs text-muted-foreground mt-10" data-testid="store-disclaimer">
          All store perks are cosmetic or quality-of-life — Southside Roleplay is never pay-to-win.
        </p>
      </section>
      <Footer />
    </div>
  );
}
